import React, { ReactNode } from 'react';
import { ItemDataType } from 'rsuite5/esm/@types/common';
import { IconButton } from 'rsuite';
import { SelectPickerProps as RSSelectPickerProps } from 'rsuite5';
import { SelectPicker } from '../formik-rsuite';
import { FieldProps } from 'formik';
import Image from './Image';
import usePrefix from '@/hooks/usePrefix';
import { FORM_DEFAULT_DISPLAY } from '@/constants/config';

export interface SelectPickerProps extends Omit<RSSelectPickerProps<any>, 'form'>, FieldProps {}

const getLabel = (value: any, pickerData: ItemDataType[]) => {
  return pickerData.find((item) => item.value == value)?.label ?? '';
};

const BicesterPickerWithCheck = ({
  field,
  form,
  isEdit,
  data,
  className,
  style,
  placeholder = ' ',
  defaultValue,
  currentLabel,
  cleanable,
  onClean,
  checkKey,
  checkLabel,
  onCheck,
  ...props
}: {
  isEdit: boolean;
  data: ItemDataType[];
  className?: string;
  style?: any;
  placeholder?: ReactNode;
  defaultValue?: any;
  currentLabel?: string; // 接收的数据不在下拉框中，非编辑状态下展示
  cleanable?: boolean;
  onClean?: (event: React.SyntheticEvent<Element, Event>) => void;
  checkKey: string; // checkbox单选框的key
  checkLabel: string; // checkbox单选框的label
  onCheck?: (key: string, value: any) => void; // 点击单选框
  [rest: string]: any;
} & SelectPickerProps) => {
  const { prefix, classname } = usePrefix('bicester-pickerwithcheck');

  return (
    <div className={classname}>
      {isEdit ? (
        <SelectPicker
          field={field}
          form={form}
          className={className}
          data={data}
          style={style}
          placeholder={placeholder}
          defaultValue={defaultValue}
          searchable={false}
          cleanable={cleanable}
          onClean={(event) => {
            onClean && onClean(event);
            // 当前picker原本有值且已被选中，清除picker值后取消选中状态
            if (field.value && field.value === form.values[checkKey]) {
              form.setFieldValue(checkKey, '');
            }
            form.setFieldValue(field.name, '');
          }}
          name={field.name}
          value={field.value}
          onChange={(value, event) => {
            // 当前picker原本有值且已被选中，改变picker值后保持被选中状态
            if (field.value && field.value === form.values[checkKey]) {
              form.setFieldValue(checkKey, value);
            }
            form.setFieldValue(field.name, value);
            field.onChange(event);
          }}
          {...props}
        />
      ) : (
        <div className={prefix('content-wrap-text')}>
          {getLabel(field.value, data) || currentLabel || FORM_DEFAULT_DISPLAY}
        </div>
      )}
      <IconButton
        className={`checkbox-wrap ${
          field.value && form.values[checkKey] === field.value ? 'checked' : ''
        }`}
        disabled={!isEdit || !field.value}
        onClick={() => {
          if (isEdit) {
            form.setFieldValue(checkKey, field.value === form.values[checkKey] ? '' : field.value);
            onCheck && onCheck(field.name, field.value);
          }
        }}
      >
        <Image
          src={`/resources/images/checkbox${
            field.value && form.values[checkKey] === field.value ? '-checked' : ''
          }.svg`}
        />
        <div className="text-[12px] ml-[5px]">{checkLabel}</div>
      </IconButton>
    </div>
  );
};

export default BicesterPickerWithCheck;
